import { render, staticRenderFns } from "./offer-favourites.vue?vue&type=template&id=0d121f65&scoped=true&"
import script from "./offer-favourites.vue?vue&type=script&lang=js&"
export * from "./offer-favourites.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0d121f65",
  null
  ,true
)

export default component.exports